<div class="dialog-container">
  <div class="dialog-header">
    <div class="header-title">{{ data.title }}</div>
    <div class="close-icon-wrapper" (click)="onCancel()">
      <i class="far fa-times close-icon"></i>
    </div>
  </div>

  <div class="dialog-content">
    <div class="filter-section">
      <app-filter-input
        [(model)]="filterText"
        [label]="data.listHeaderText || ('users:filterLabel' | i18next)"
        width="330px"
        size="medium">
      </app-filter-input>
    </div>

    <div class="resource-list">
      <div class="resource-item" *ngFor="let resource of filteredResources" (click)="selectResource(resource)">
        <div class="resource-name" [matTooltip]="decodeHtmlEntities(resource.description)" matTooltipClass="tooltip-font-14"
          [matTooltipDisabled]="resource.description?.length < 100">
          {{ decodeHtmlEntities(resource.description) }}
        </div>
      </div>

      <div *ngIf="filteredResources.length === 0" class="no-resources">
        {{ 'realtime:noResults' | i18next }}
      </div>
    </div>
  </div>
</div>

